export const COMPETENCIES_NAME_REQUEST = "COMPETENCIES_NAME_REQUEST";
export const COMPETENCIES_NAME_SUCCESS = "COMPETENCIES_NAME_SUCCESS";
export const COMPETENCIES_NAME_FAIL = "COMPETENCIES_NAME_FAIL";
export const COMPETENCIES_NAME_CLEAR_ERRORS = "COMPETENCIES_NAME_CLEAR_ERRORS";
